import { render } from "./ArticleItem.vue?vue&type=template&id=b9d56962&ts=true"
import script from "./ArticleItem.vue?vue&type=script&lang=ts"
export * from "./ArticleItem.vue?vue&type=script&lang=ts"

import "./ArticleItem.vue?vue&type=style&index=0&id=b9d56962&lang=scss"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__